import React, { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom"

//import { cookieUpdate, cookieRemove } from '../../cookies'
import { useCookies } from 'react-cookie'
import debounce from '../../debounce'
import { callApi } from '../../api/client'

import themes from 'devextreme/ui/themes'
import Notify from 'devextreme/ui/notify'
import Toolbar, { Item } from 'devextreme-react/toolbar'
import { SelectBox, TextBox, DropDownButton, Popover, Tooltip, Chat } from 'devextreme-react'
import CustomStore from 'devextreme/data/custom_store'

import { useMsal, useIsAuthenticated } from "@azure/msal-react"

import { currentCompany, setTheme, setCompany } from '../company/companySlice'
import { currentUser, currentPerm, userToken, userSrchTerm, setSrchTerm, setColorMode, setUser } from '../user/userSlice'

import { HubConnectionState } from '@microsoft/signalr'
import { signalrCon, taskUpdates, removeTaskUpdate, userMessages, removeMessage, signalrPeers, openNew, sentMessage } from '../../api/signalrSlice'
import ProgressDialog from '../common/ProgressDialog'
import ChatDialog from '../common/ChatDialog'

import { useTheme } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

import './nav.css'
import '../../theme/fontawesome.css'
import '../../theme/duotone.css'

const Navbar = (props) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const theme = useTheme()

    const { instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated()

    const [cookies, setCookie, removeCookie] = useCookies(['session_var'])

    const [companies, setCompanies] = useState([])
    const [dialogs, setDialogs] = useState([])

    const dialogsRef = useRef()
    dialogsRef.current = dialogs

    const currentcompany = useSelector(currentCompany)
    const currentuser = useSelector(currentUser)
    const currentperm = useSelector(currentPerm)
    const token = useSelector(userToken)
    const srchTerm = useSelector(userSrchTerm)
    const signalr = useSelector(signalrCon)
    const taskupdates = useSelector(taskUpdates)
    const usermessages = useSelector(userMessages)
    const signalrpeers = useSelector(signalrPeers)

    const userSelectRef = useRef()
    const companySelectRef = useRef()
    const userStore = new CustomStore({
        loadMode: 'processed',
        key: 'id',
        load: (opt) => {
            return new Promise((resolve) => {
                if (isAuthenticated) {
                    const params = {
                        companyid: currentcompany.id,
                        userid: currentuser.id,
                        admin: currentperm.adminGpsi,
                        searchValue: JSON.stringify(opt['searchValue']),
                    }
                    callApi('Users/GetUsers', params)
                        .then(res => {
                            resolve(res)
                        }).catch(err => {
                            Notify({
                                message: err,
                                minHeight: 45,
                                minWidth: 150,
                                type: 'error',
                            }, {
                                position: 'bottom center',
                                direction: 'up-push'
                            })
                            resolve(null)
                        })
                } else {
                    resolve(null)
                }
            })
        },
        byKey: (key) => {
            return new Promise((resolve) => {
                if (isAuthenticated) {
                    const params = {
                        companyid: currentcompany.id,
                        userid: currentuser.id,
                        admin: currentperm ? currentperm.adminGpsi : false,
                        key: key,
                    }
                    callApi('Users/GetUsers', params)
                        .then(res => {
                            resolve(res[0])
                        }).catch(err => {
                            Notify({
                                message: err,
                                minHeight: 45,
                                minWidth: 150,
                                type: 'error',
                            }, {
                                position: 'bottom center',
                                direction: 'up-push'
                            })
                            resolve(null)
                        })
                } else {
                    resolve(null)
                }
            })
        }
    })

    useEffect(() => {
        if (currentcompany.id !== 0) {
            if (companies.findIndex(f => f.id === currentcompany.id) === -1) {
                setCompanies([currentcompany])
            }
        }
    }, [currentcompany, isAuthenticated]);
    useEffect(() => {
        if (taskupdates.length > 0) {
            taskupdates.forEach(item => taskUpdated(item))
        }
    }, [taskupdates]);
    useEffect(() => {
        if (usermessages.length > 0) {
            usermessages.forEach(item => messageUpdated(item))
        }
    }, [usermessages]);

    const taskUpdated = (data) => {
        const idx = dialogsRef.current.findIndex(f => f.id === data.taskName)
        if (idx === -1) {
            setDialogs((d) => [...d, {
                id: data.taskName,
                title: `Task ${data.taskName}`,
                onCancel: closeDialog,
                hide: false,
                data: data,
                type: 'progress'
            }])
        } else {
            const dArr = [...dialogsRef.current]
            if (!dArr[idx].hide) {
                dArr[idx].data = data
                setDialogs(dArr)
            }
        }
    }
    const messageUpdated = (data) => {
        const idx = dialogsRef.current.findIndex(f => f.id === `chat_${data.id}`)
        if (idx === -1) {
            if (currentperm.adminGpsi) {
                setDialogs((d) => [...d, {
                    id: `chat_${data.id}`,
                    usr: { id: accounts[0].localAccountId, name: currentuser.name },
                    onHidden: closeDialog,
                    onSend: messageSend,
                    onClear: clearMessages,
                    hide: false,
                    data: data,
                    type: 'chat'
                }])
            }
        } else {
            const dArr = [...dialogsRef.current]
            if (!dArr[idx].hide) {
                dArr[idx].data = data
                setDialogs(dArr)
            }
        }
    }
    const messageSend = (message,id) => {
        dispatch({ type: 'sendUser', userId: id, message: message.text })
        dispatch(sentMessage({ id: id, message: message }))
    }
    const clearMessages = (dialogId, id) => {
        closeDialog(dialogId)
        dispatch(removeMessage(id))
    }
    const closeDialog = (id) => {
        const idx = dialogsRef.current.findIndex(f => f.id === id)
        if (idx !== -1) {
            if (dialogsRef.current[idx]?.type === 'progress') {
                dispatch(removeTaskUpdate(id))
            //} else if (dialogsRef.current[idx]?.type === 'chat') {
            //    dispatch(removeMessage(dialogsRef.current[idx].data.id))
            }
            const dArr = [...dialogsRef.current]
            dArr.splice(idx, 1)
            setDialogs(dArr)
        }
    }
    const getCompany = (cid) => {
        callApi('companies/GetCompanyCid', cid)
            .then(resp => {
                cookies.session_var.mcid = cid
                setCookie('session_var', cookies.session_var, {
                    httpOnly: false,
                    path: '/',
                    secure: true,
                    domain: 'fleetconnect.com.au',
                })
                dispatch(setCompany(resp))
            }).catch(error =>
                Notify({
                    message: error,
                    minHeight: 45,
                    minWidth: 150,
                    type: 'error',
                }, {
                    position: 'bottom center',
                    direction: 'up-push'
                })
            )
    }
    const getUser = (uid) => {
        callApi('Users/GetCurrentUser', uid)
            .then(resp => {
                cookies.session_var.muid = uid
                setCookie('session_var', cookies.session_var, {
                    httpOnly: false,
                    path: '/',
                    secure: true,
                    domain: 'fleetconnect.com.au',
                })
                dispatch(setUser(resp))
                if (resp.companyid !== currentcompany.id) {
                    getCompany(resp.companyid)
                }
            }).catch(error =>
                Notify({
                    message: error,
                    minHeight: 45,
                    minWidth: 150,
                    type: 'error',
                }, {
                    position: 'bottom center',
                    direction: 'up-push'
                })
            )
    }

    const handleSearchDone = (e) => {
        const value = e.event.target.value
        dispatch(setSrchTerm(value.trim()))
    }
    const handleCompanyChange = (e) => {
        if (e.selectedItem && e.selectedItem?.id !== currentcompany.id) {
            getCompany(e.selectedItem.id)
        }
    }
    const handleCompanyOpen = (e) => {
        callApi('companies/GetDescendants', currentuser.gpsi ? 1 : currentuser.companyid)
            .then(data => {
                if (!!data) {
                    setCompanies(data) //.sort((a, b) => a.name.localeCompare(b.name)))
                } else {
                    setCompanies([currentcompany])
                }
            }).catch(err => {
                Notify({
                    message: err,
                    minHeight: 45,
                    minWidth: 150,
                    type: 'error',
                }, {
                    position: 'bottom center',
                    direction: 'up-push'
                })
                setCompanies([currentcompany])
            })
    }
    const handleCompanyClose = (e) => {
        setCompanies([currentcompany])
    }
    const handleUserChange = (e) => {
        if (e.selectedItem && e.selectedItem?.id !== currentuser.id) {
            getUser(e.selectedItem?.id)
        }
    }

    //const handleTheme = () => {
    //    themes.current('material.summit')
    //    dispatch(setTheme('summitconnect'))
    //}
    const handleEditUser = () => {
        navigate('/Admin/User', { state: { id: currentuser.id, tab: 0 } })
    }
    const handleUpdateOdo = () => {
    //    window.location = `${process.env.REACT_APP_PartnerUri}/Content/UpdateOdometer.aspx`
    }
    const handleLegals = () => {
        window.location = `${process.env.REACT_APP_PartnerUri}/Content/Legals.aspx`
    }
    const handleLogout = () => {
        callApi('Users/AuthLogout', { companyid: currentcompany.id, userid: currentuser.id })
            .then(data => {
                dispatch({ type: 'disconnect' })
                removeCookie('session_var')
                instance.logoutRedirect({
                    postLogoutRedirectUri: "/",
                })
            }).catch(err => {
                Notify({
                    message: err,
                    minHeight: 45,
                    minWidth: 150,
                    type: 'error',
                }, {
                    position: 'bottom center',
                    direction: 'up-push'
                })
                dispatch({ type: 'disconnect' })
                removeCookie('session_var')
                instance.logoutRedirect({
                    postLogoutRedirectUri: "/",
                })
            })
        // dispatch({ type: 'disconnect' })
        // removeCookie('session_var')
        // instance.logoutRedirect({
        //     postLogoutRedirectUri: "/",
        // })
    }

    const handleSignalrClick = (e) => {
        if (signalr.state === HubConnectionState.Connected) {
            dispatch({ type: 'sendServer', function: 'GetConnections' })
        } else {
            dispatch({ type: 'connect', accessToken: token })
        }
    }
    const handleSignalrItmClick = (e) => {
        const itm = usermessages.find(f => f.id === e.itemData.id)
        if (itm) {
            setDialogs((d) => [...d, {
                id: `chat_${itm.id}`,
                usr: { id: currentuser.id, name: currentuser.name },
                onHidden: closeDialog,
                onSend: messageSend,
                onClear: clearMessages,
                hide: false,
                data: itm,
                type: 'chat'
            }])
        } else {
            dispatch(openNew({ id: e.itemData.id, name: e.itemData.text }))
        }
    }

    const supportClick = (e) => {
        //navigate('/Support')
        window.location = `${process.env.REACT_APP_PartnerUri}/SupportCode/SupportForm.aspx`
    }
    const userListRender = (d) => {
        return (
            <Box>
                <Typography variant='menuSubTitle' sx={{ color: theme.palette.secondary.main }} >
                    {`${d.name} (${d.id})`}
                </Typography>
                <Typography variant='body2'>
                    {d.company}
                </Typography>
                <Typography variant='body2'>
                    {d.email}
                </Typography>
                <Typography variant='body2'>
                    {`Group: ${d.group}`}
                </Typography>
                <Typography variant='body2'>
                    {`Perm: ${d.perm}`}
                </Typography>
            </Box>
            )
    }
    return (
        <>
            <Toolbar id='signalrAnchor' >
                <Item
                    location='before'
                    locateInMenu='never'
                    widget='dxButton'
                    options={{
                        type: 'normal',
                        stylingMode: 'text',
                        icon: 'fa-duotone fa-bars',
                        onClick: () => props.setDrawerState(true)
                    }}
                    visible={!props.drawerState}
                />
                <Item
                    location='before'
                    locateInMenu='never'>
                    <TextBox
                        width={250}
                        mode='search'
                        stylingMode='filled'
                        placeholder='Search'
                        defaultValue={srchTerm}
                        onInput={debounce((e) => handleSearchDone(e), 1000)}/>
                </Item>
                <Item
                    location='after'
                    locateInMenu='auto'>
                    <SelectBox ref={companySelectRef}
                        width='300'
                        stylingMode='filled'
                        dropDownOptions={{ width: 300, }}
                        inputAttr={{ style: `color: ${theme.palette.secondary.main}` }}
                        searchEnabled={true}
                        dataSource={companies}
                        displayExpr='name'
                        value={currentcompany}
                        onOpened={handleCompanyOpen}
                        onClosed={handleCompanyClose}
                        onSelectionChanged={handleCompanyChange}
                        onFocusIn={(e) => e.element.querySelector('input.dx-texteditor-input').select()}
                    />
                </Item>
                <Item
                    location='after'
                    locateInMenu='auto'>
                    <SelectBox ref={userSelectRef}
                        width='210'
                        readOnly={!currentperm?.adminGpsi}
                        stylingMode='filled'
                        inputAttr={{ style: `color: ${theme.palette.secondary.main}` }}
                        dataSource={userStore}
                        displayExpr='name'
                        value={currentuser}
                        searchEnabled={true}
                        showDataBeforeSearch={false}
                        minSearchLength={3}
                        onSelectionChanged={handleUserChange}
                        itemRender={userListRender}
                        onFocusIn={(e) => e.element.querySelector('input.dx-texteditor-input').select()}
                    />
                </Item>
                <Item
                    location='after'
                    locateInMenu='auto'>
                    <DropDownButton
                        hint='User Menu'
                        stylingMode='text'
                        showArrowIcon={false}
                        icon='fa-duotone fa-circle-user'
                        elementAttr={{ id: 'usrmnu' }}
                        dropDownOptions={{
                            width: 200,
                            position: {
                                my: 'right top',
                                at: 'right bottom',
                                of: '#usrmnu'
                            } }}
                        items={
                            [{
                                icon: 'fa-duotone fa-file-pen',
                                text: 'Edit Profile',
                                onClick: handleEditUser
                            }, {
                                icon: 'fa-duotone fa-gauge-circle-bolt',
                                text: 'Update Odometer',
                                onClick: handleUpdateOdo
                            }, {
                                icon: 'fa-duotone fa-file-contract',
                                text: 'Legals',
                                onClick: handleLegals
                            }, {
                                icon: 'fa-duotone fa-arrow-right-from-bracket',
                                text: 'Logout',
                                onClick: handleLogout
                            }]}
                    />
                </Item>
                <Item
                    location='after'
                    locateInMenu='auto'
                    visible={currentperm?.adminGpsi}
                >
                    <DropDownButton
                        stylingMode='text'
                        showArrowIcon={false}
                        icon={signalr.state === HubConnectionState.Connected ? 'fa-duotone fa-link-horizontal' : 'fa-duotone fa-link-horizontal-slash'}
                        elementAttr={{ id: 'signalrmnu' }}
                        dropDownOptions={{
                            width: 200,
                            position: {
                                my: 'right top',
                                at: 'right bottom',
                                of: '#signalrmnu',
                                collision: 'fit'
                            }
                        }}
                        onButtonClick={handleSignalrClick}
                        onItemClick={handleSignalrItmClick}
                        items={
                            signalrpeers.map((peer) => {
                                return { id: peer.id, icon: 'fa-duotone fa-user', text: peer.name }
                            })
                        }
                    />
                </Item>
                <Item
                    location='after'
                    locateInMenu='auto'
                    widget='dxButton'
                    options={{
                        hint: 'Go to Support',
                        type: 'normal',
                        stylingMode: 'text',
                        icon: 'fa-duotone fa-life-ring',
                        onClick: supportClick,
                    }}
                />
            </Toolbar>
            {dialogs.map((dialog) => {
                if (!dialog.hide) {
                    if (dialog.type === 'progress') {
                        return (
                            <ProgressDialog {...dialog} />
                        )
                    } else if (dialog.type === 'chat') {
                        return (
                            <ChatDialog {...dialog} />
                        )
                    }
                }
            })}
        </>
  );
};

export default Navbar;
